
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';
import { getValidateCode, loginUser } from '@/api/apis';
import router from '../router';
import { encrypt } from '@/utils/crypt';
import UserIcon from '@/components/icons/UserIcon.vue';
import LockIcon from '@/components/icons/LockIcon.vue';

export default defineComponent({
  name: 'Login',
  components: {
    UserIcon,
    LockIcon
  },
  data() {
    return {
      loading: false,
      validateImg: null,
      form: {
        username: undefined,
        password: undefined,
        checkKey: 'key_' + (Math.floor(Math.random() * 10000) + 10000),
        captcha: undefined
      }
    };
  },
  created() {
    this.getEncryptedString();
  },
  computed: {
    ...mapState({
      encryptedString: (state: any) => state.encryptedString
    }),
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    ...mapActions(['getEncryptedString', 'setTokenAndUserInfo']),
    onSubmit() {
      (this.$refs as any).form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await loginUser({
            ...this.form,
            password: encrypt(
              this.form.password,
              this.encryptedString.key,
              this.encryptedString.iv
            )
          });
          if (res.success) {
            this.setTokenAndUserInfo({ ...res.result });

            if (router.currentRoute.value.redirectedFrom) {
              const redirectPath =
                router.currentRoute.value.redirectedFrom?.path;
              const query = router.currentRoute.value.redirectedFrom?.query;
              router.replace({
                path: redirectPath,
                query
              });
            } else {
              if (router.currentRoute.value.query.redirect) {
                router.replace({
                  path: router.currentRoute.value.query.redirect as string
                });
              } else {
                router.replace({
                  path: '/vehicle'
                });
              }
            }
          }
          this.loading = false;
        })
        .catch(error => error);
    },
    goToHome() {
      this.$router.push('/');
    },
    async getValidateCode() {
      const res = await getValidateCode(this.form.checkKey);
      if (res.success) {
        this.validateImg = res.result;
      }
    }
  }
});
